module.exports = __webpack_public_path__ + "assets/img/6a64678fd4e281ec247aa4ee85baabf5.png";